module.exports = __webpack_public_path__ + "static/media/webstorm.e00a3773.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/webstorm.png
// module id = 213
// module chunks = 0